// ============================================================================
// TRIYUGINARAYAN WEDDING COLLECTION · MASTER REGISTRY
// ============================================================================
// Six curated collections + one fully-custom offering. Nineteen packages total.
// Every price is "Starting From" — the final quotation is generated by the
// Live Estimator (based on guest count, accommodation, décor, catering,
// photography, transport, wedding events, and add-ons) and confirmed on WhatsApp.
//
// AI Attribution:
//   - Every experience card is marked as "Illustrative Vision" until a real
//     Google Review is fetched. Names, ratings and review counts are NEVER
//     fabricated. See <Reviews /> in BookWedding.jsx.
// ============================================================================

// ----- Curated Kedarnath / Triyuginarayan wedding imagery (verified URLs) ----
const IMG = {
  mandapDawn:     "https://images.unsplash.com/photo-1587271636175-90d58cdad458?auto=format&fit=crop&w=1600&q=85",
  templeMorning:  "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1600&q=85",
  bridalHands:    "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1600&q=85",
  garland:        "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1600&q=85",
  meadowMandap:   "https://images.pexels.com/photos/14149541/pexels-photo-14149541.jpeg?auto=compress&cs=tinysrgb&w=1600&q=85",
  riversideVows:  "https://images.unsplash.com/photo-1544198365-f5d60b6d8190?auto=format&fit=crop&w=1600&q=85",
  duo:            "https://images.unsplash.com/photo-1465495976277-4387d4b0e4a6?auto=format&fit=crop&w=1600&q=85",
  brideCloseup:   "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1600&q=85",
  candles:        "https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1600&q=85",
  goldRings:      "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?auto=format&fit=crop&w=1600&q=85",
  petals:         "https://images.unsplash.com/photo-1591780980986-5c8bcbb6f27b?auto=format&fit=crop&w=1600&q=85",
  himalayaMorning:"https://images.unsplash.com/photo-1580689149673-83a8e1e6b6a9?auto=format&fit=crop&w=1600&q=85",
  ganga:          "https://images.unsplash.com/photo-1560195587-4a9256134f68?auto=format&fit=crop&w=1600&q=85",
  aarti:          "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1600&q=85",
  hero:           "https://images.unsplash.com/photo-1587271636175-90d58cdad458?auto=format&fit=crop&w=2000&q=80",
};

// ----- Illustrative experience cards (labelled clearly · no fake identities) -
export const ILLUSTRATIVE_EXPERIENCES = [
  { id: "vision-1", quote: "The kind of morning where the Mandakini becomes your witness. Pheras beside the eternal Akhand Dhuni — every detail held with quiet grace.", context: "Illustrative Vision · Sacred Vow, Triyuginarayan" },
  { id: "vision-2", quote: "A copper-lit sangeet in the meadow, Himalayan peaks turning gold behind. The Cormorant menu, the Yatra One playlist — nothing generic, nothing rushed.", context: "Illustrative Vision · Signature Riverside" },
  { id: "vision-3", quote: "Elders reach Kedarnath by helicopter at dawn, return in time for evening aarti. The wedding becomes pilgrimage, and pilgrimage becomes celebration.", context: "Illustrative Vision · Celestial Blessing" },
  { id: "vision-4", quote: "Every family member greeted by name. Doli for the bride at Triyuginarayan. Every mantra chanted the way the ancestors intended.", context: "Illustrative Vision · Traditional Vedic" },
];

// ----- Shared: FAQ pool (used across collections) ---------------------------
const FAQ_COMMON = [
  { q: "What season is best for a Triyuginarayan wedding?",
    a: "April to mid-June and mid-September to early November are ideal. Monsoon (Jul–Aug) is restricted due to Char Dham yatra logistics. December–March offers stunning snow backdrops but requires cold-weather planning." },
  { q: "Do you handle the pheras at the actual Triyuginarayan Temple?",
    a: "Yes. We coordinate with the Temple Committee, secure permissions, arrange a KC-approved pandit for authentic Vedic ceremonies, and manage the Akhand Dhuni offerings that make this shrine so unique." },
  { q: "How far in advance should we book?",
    a: "For peak-season (Apr–Jun, Oct–Nov) we recommend 4–6 months. Winter weddings can be planned in 8–10 weeks. Royal (150+ guest) weddings need 6+ months for logistics and accommodation blocks." },
  { q: "Can we combine the wedding with a Char Dham yatra?",
    a: "Absolutely — many couples do. We craft a post-wedding yatra add-on (Kedarnath darshan, Badrinath, or full Char Dham) for the couple and select family. Ask about our Wedding + Yatra combos." },
  { q: "Is the price shown final?",
    a: "The listed price is 'Starting From' — the base for the given tier. Your final quotation is generated by our Live Estimator (guest count, accommodation, décor, catering, photo/video, transport, events, add-ons) and locked over WhatsApp." },
];

// ----- Common add-ons available to every collection --------------------------
const ADDONS_STD = [
  { key: "live_music",       label: "Live Classical / Sufi Ensemble", price: 45000 },
  { key: "dhol_baraat",      label: "Dhol · Baraat Procession",        price: 25000 },
  { key: "fireworks",        label: "Silent Cold Pyros / Fireworks",   price: 60000 },
  { key: "drone_cinema",     label: "Drone Cinematography",            price: 35000 },
  { key: "helicopter_arrival",label: "Helicopter Arrival · Baraati",   price: 285000 },
  { key: "vedic_pandit",     label: "Senior Vedic Pandit + Rituals",   price: 21000 },
  { key: "mehendi_artist",   label: "Signature Mehendi Artist",        price: 30000 },
  { key: "bridal_makeup",    label: "Celebrity Bridal Makeup Team",    price: 85000 },
  { key: "spa_wellness",     label: "Bride & Groom Spa · Wellness",    price: 25000 },
];

// ----- The 7 Collections -----------------------------------------------------
export const WEDDING_COLLECTIONS = [
  // ============================================================
  // 1. BOUTIQUE WEDDING · up to 20 guests
  // ============================================================
  {
    id: "boutique",
    icon: "heart",
    name: "Boutique Wedding",
    guestRange: "Up to 20 Guests",
    guestMax: 20,
    tagline: "Sacred · Intimate · Held with grace",
    heroLine: "The wedding you always imagined — small, sacred, and utterly yours.",
    image: IMG.mandapDawn,
    accent: "amber",
    overview: "For couples who want the temple, the Himalayas, and the vow — with only the people who matter most. A day that feels like a whispered prayer, not a public event.",
    highlights: [
      "Sacred pheras at Triyuginarayan Temple, arranged with the Temple Committee",
      "One night at Kedarnath Cottage or a boutique heritage stay in Sersi / Rudraprayag",
      "KC-approved pandit for authentic Vedic ceremonies",
      "Wedding-style meal for 20 — pahadi thali or curated fine-dine",
      "Photo + video coverage (basic to signature depending on tier)",
    ],
    included: [
      "Venue coordination (temple permission + décor setup)",
      "Bride & groom rooms with fresh flowers",
      "Basic floral mandap + Akhand Dhuni offerings",
      "Meals for guests × wedding day + morning-after breakfast",
      "Local transport within Sersi–Triyuginarayan (up to 20 km)",
      "On-day KC coordinator throughout",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "Boutique Heritage Rooms", perNight: 5500 },
      { key: "premium",   label: "Premium Riverside Rooms", perNight: 8500 },
      { key: "luxury",    label: "Kedarnath Cottage Signature Suite", perNight: 15000 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Ertiga / Innova)",  flat: 25000 },
      { key: "premium",  label: "Premium Fleet (Crysta / Traveller)", flat: 55000 },
      { key: "luxury",   label: "Luxury Fleet + Helicopter Arrival",  flat: 285000 },
    ],
    decoration: [
      { key: "classic",   label: "Classic Floral Mandap",   flat: 45000 },
      { key: "signature", label: "Signature Copper + Bloom", flat: 95000 },
      { key: "royal",     label: "Royal Marigold Cascade",   flat: 175000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Veg",             perGuest: 1800 },
      { key: "extended",   label: "Extended Multi-Cuisine Veg",   perGuest: 2800 },
      { key: "luxury",     label: "Luxury Live Counters + Grill",  perGuest: 4500 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo",                flat: 45000 },
      { key: "cinematic",  label: "Cinematic · Photo + Reels",         flat: 125000 },
      { key: "signature",  label: "Signature · Full Film Production",  flat: 275000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Guest arrival & welcome tea by the Mandakini" },
      { day: "Day 1", label: "Pheras at Triyuginarayan · Akhand Dhuni · wedding-style dinner" },
      { day: "Day 2", label: "Farewell breakfast · optional Kedarnath darshan for the couple" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.mandapDawn, IMG.templeMorning, IMG.candles, IMG.petals, IMG.duo, IMG.bridalHands],
    tiers: [
      { id: "boutique-budget",  name: "Boutique Budget",   startingFrom: 49999,   note: "Sacred essentials · 20 guests · 1 night" },
      { id: "boutique-premium", name: "Boutique Premium",  startingFrom: 79999,   note: "Elevated hospitality · signature mandap · fine-dine" , featured: true },
      { id: "boutique-luxury",  name: "Boutique Luxury",   startingFrom: 119999,  note: "Kedarnath Cottage suite · cinematic film · full service" },
    ],
  },
  // ============================================================
  // 2. MICRO DESTINATION WEDDING · up to 30
  // ============================================================
  {
    id: "micro",
    icon: "sparkles",
    name: "Micro Destination Wedding",
    guestRange: "Up to 30 Guests",
    guestMax: 30,
    tagline: "Two nights · One vow · The Himalayas as witness",
    heroLine: "A two-day celebration for your closest thirty — with the pheras exactly where Shiva and Parvati took theirs.",
    image: IMG.templeMorning,
    accent: "gold",
    overview: "Enough time for the pre-wedding puja, the sangeet, and the pheras. Small enough that every guest feels held, large enough for a proper Indian celebration.",
    highlights: [
      "Two nights at the Kedarnath Cottage cluster (Sersi) or premium boutique stays",
      "Full pheras + Akhand Dhuni ceremony at Triyuginarayan Temple",
      "Sangeet evening under the stars in the alpine meadow",
      "Curated multi-cuisine menu with pahadi + fine-dine influences",
      "Cinematic photo + reel package",
    ],
    included: [
      "Venue coordination for pheras, sangeet, and welcome ceremonies",
      "Bride & groom suites, guest rooms in premium tier",
      "Sangeet stage + basic sound system + one-hour DJ",
      "Two-day meals: welcome-tea, sangeet dinner, wedding lunch, farewell breakfast",
      "Local transport within Sersi–Triyuginarayan circuit for all guests",
      "Dedicated KC wedding director + on-day team of 6",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "Boutique Heritage Rooms",             perNight: 6500 },
      { key: "premium",   label: "Premium Riverside Rooms",             perNight: 9500 },
      { key: "luxury",    label: "Kedarnath Cottage Signature Suites",  perNight: 17500 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Innova × 3)",          flat: 45000 },
      { key: "premium",  label: "Premium Fleet (Crysta + Traveller)",   flat: 95000 },
      { key: "luxury",   label: "Luxury Fleet + Heli for Immediate Family", flat: 385000 },
    ],
    decoration: [
      { key: "classic",   label: "Classic Floral Mandap + Sangeet Stage",   flat: 85000 },
      { key: "signature", label: "Signature Copper + Bloom + Cocktail Lounge", flat: 165000 },
      { key: "royal",     label: "Royal Marigold + Chandelier + Themed Sangeet", flat: 285000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Veg (2 meals)",          perGuest: 2200 },
      { key: "extended",   label: "Extended Multi-Cuisine Veg (5 meals)", perGuest: 3200 },
      { key: "luxury",     label: "Luxury Live Counters + Grill + Cocktails", perGuest: 5500 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo + 1-min Reel",           flat: 75000 },
      { key: "cinematic",  label: "Cinematic · Photo + Reels + Highlight Film", flat: 185000 },
      { key: "signature",  label: "Signature · Feature Film + Album",           flat: 350000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Guest arrival · Welcome tea + evening aarti on the Mandakini" },
      { day: "Day 1", label: "Haldi / Mehendi morning · Sangeet under the stars in the meadow" },
      { day: "Day 2", label: "Pheras at Triyuginarayan Temple · Wedding-style lunch · Cocktail evening" },
      { day: "Day 3", label: "Farewell breakfast · Family Kedarnath darshan option" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.templeMorning, IMG.garland, IMG.duo, IMG.candles, IMG.riversideVows, IMG.goldRings],
    tiers: [
      { id: "micro-budget",  name: "Micro Budget",   startingFrom: 149999,  note: "Curated essentials · 30 guests · 2 nights" },
      { id: "micro-premium", name: "Micro Premium",  startingFrom: 249999,  note: "Sangeet + pheras + cinematic film", featured: true },
      { id: "micro-luxury",  name: "Micro Luxury",   startingFrom: 349999,  note: "Signature suites · full production · heli option" },
    ],
  },
  // ============================================================
  // 3. PREMIUM DESTINATION WEDDING · 31–80
  // ============================================================
  {
    id: "premium",
    icon: "temple",
    name: "Premium Destination Wedding",
    guestRange: "31 – 80 Guests",
    guestMax: 80,
    tagline: "Three days · Three ceremonies · One eternal vow",
    heroLine: "A full-scale Indian wedding celebration in the alpine Himalayas — with the sanctity of Triyuginarayan and the hospitality of Kedarnath Cottage.",
    image: IMG.meadowMandap,
    accent: "gold",
    overview: "The classic destination wedding — sangeet, haldi/mehendi, wedding, and reception spread across three unforgettable days in Sersi and Triyuginarayan.",
    highlights: [
      "Three nights in Kedarnath Cottage + partner premium properties",
      "Full ceremony arc: Haldi · Mehendi · Sangeet · Pheras · Reception",
      "Meadow sangeet with copper lighting + curated live music",
      "Multi-cuisine menu with pahadi accents + live counters",
      "Cinematic film production + drone coverage",
    ],
    included: [
      "Venue for 5 ceremonies (welcome, haldi/mehendi, sangeet, wedding, reception)",
      "60–80 rooms across KC cluster + partner premium properties",
      "Stage · lighting · sound · dance floor for sangeet",
      "5-day meal plan + welcome + farewell brunch",
      "Airport pickup from Dehradun for all guests",
      "Wedding director + 10-member on-ground team",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "Boutique Rooms · Partner Properties", perNight: 7500 },
      { key: "premium",   label: "Premium Riverside Rooms",             perNight: 11500 },
      { key: "luxury",    label: "Kedarnath Cottage Signature Suites",  perNight: 19500 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Travellers × 5)",       flat: 145000 },
      { key: "premium",  label: "Premium Fleet (Crysta + Urbania)",      flat: 285000 },
      { key: "luxury",   label: "Luxury Fleet + Family Heli Arrivals",   flat: 685000 },
    ],
    decoration: [
      { key: "classic",   label: "Classic Floral Mandap + Sangeet Set",       flat: 185000 },
      { key: "signature", label: "Signature Copper + Bloom + Reception Set",   flat: 385000 },
      { key: "royal",     label: "Royal Themed Décor across all 5 ceremonies", flat: 685000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Veg (5 meal plan)",     perGuest: 3500 },
      { key: "extended",   label: "Extended Multi-Cuisine Veg + Chaat",  perGuest: 4800 },
      { key: "luxury",     label: "Luxury Live Counters + Grill + Bar",  perGuest: 7500 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo + Reels",                       flat: 185000 },
      { key: "cinematic",  label: "Cinematic · Feature Film + Same-Day Edit",         flat: 385000 },
      { key: "signature",  label: "Signature · 3-Cam Film + Drone + Full Production", flat: 685000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Guest arrivals · Welcome dinner + aarti on Mandakini" },
      { day: "Day 1", label: "Haldi morning · Mehendi afternoon · Sangeet in the meadow" },
      { day: "Day 2", label: "Pheras at Triyuginarayan · Wedding-style lunch" },
      { day: "Day 3", label: "Reception at KC · Farewell brunch · Kedarnath darshan option" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.meadowMandap, IMG.mandapDawn, IMG.aarti, IMG.duo, IMG.candles, IMG.himalayaMorning],
    tiers: [
      { id: "premium-classic", name: "Premium Classic",  startingFrom: 399999,  note: "5 ceremonies · 3 nights · 50 guests baseline" },
      { id: "premium-plus",    name: "Premium Plus",     startingFrom: 599999,  note: "Signature décor · cinematic film · premium rooms", featured: true },
      { id: "premium-luxury",  name: "Premium Luxury",   startingFrom: 799999,  note: "Full luxury · heli option · full production" },
    ],
  },
  // ============================================================
  // 4. LUXURY DESTINATION WEDDING · 81–150
  // ============================================================
  {
    id: "luxury",
    icon: "crown",
    name: "Luxury Destination Wedding",
    guestRange: "81 – 150 Guests",
    guestMax: 150,
    tagline: "The wedding as an offering · A celebration on the scale it deserves",
    heroLine: "A luxury Himalayan wedding that feels as effortless for 150 as it does for 20 — because our hospitality doesn't scale with the guest count, it scales with the intent.",
    image: IMG.riversideVows,
    accent: "gold",
    overview: "For families ready to celebrate on a grand scale — with full luxury inventory (Kedarnath Cottage buyout + partner luxury properties), signature production values, and dedicated helicopter arrivals for immediate family.",
    highlights: [
      "Kedarnath Cottage full buyout + 60 rooms in partner luxury properties",
      "Dedicated 20-member wedding production team",
      "Themed décor across 5 ceremonies with copper, brass, and bloom",
      "Multi-cuisine live counters + celebrity chef pop-up option",
      "3-camera feature film + drone + same-day edit",
    ],
    included: [
      "Full property buyout + 60 rooms in partner luxury properties (3 nights)",
      "5 fully-designed ceremonies with dedicated production sets",
      "Full sound + lighting + dance floor + LED wall for sangeet + reception",
      "5-day gourmet meal plan with dietary customisation for every guest",
      "Airport pickup from Dehradun for all 150 guests + on-property transport",
      "Wedding director + 20-member on-ground team + concierge for every family",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "Boutique Rooms · Partner Luxury Properties", perNight: 9500 },
      { key: "premium",   label: "Premium Riverside Rooms + KC Cottages",       perNight: 14500 },
      { key: "luxury",    label: "KC Signature Suites + Partner Luxury Villas", perNight: 24500 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Travellers × 10)",            flat: 285000 },
      { key: "premium",  label: "Premium Fleet (Urbania + Crysta × 8)",         flat: 585000 },
      { key: "luxury",   label: "Luxury Fleet + Family Heli Arrivals + Mini Bus", flat: 1250000 },
    ],
    decoration: [
      { key: "classic",   label: "Classic Themed Décor · 5 ceremonies",       flat: 385000 },
      { key: "signature", label: "Signature Copper + Bloom · 5 ceremonies",    flat: 685000 },
      { key: "royal",     label: "Royal Themed Production · 5 ceremonies",     flat: 1150000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Veg (5 meal plan)",           perGuest: 4500 },
      { key: "extended",   label: "Extended Multi-Cuisine Veg + Chaat",        perGuest: 5800 },
      { key: "luxury",     label: "Luxury Live Counters + Grill + Bar + Celebrity Chef", perGuest: 8500 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo + Reels",                       flat: 285000 },
      { key: "cinematic",  label: "Cinematic · Feature Film + Same-Day Edit",         flat: 585000 },
      { key: "signature",  label: "Signature · 3-Cam Film + Drone + Full Production", flat: 985000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Guest arrivals in staggered batches · Welcome dinner" },
      { day: "Day 1", label: "Haldi morning · Mehendi afternoon · Grand Sangeet" },
      { day: "Day 2", label: "Pheras at Triyuginarayan · Wedding-style lunch for 150" },
      { day: "Day 3", label: "Grand Reception · Farewell brunch · Kedarnath darshan option" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.riversideVows, IMG.mandapDawn, IMG.meadowMandap, IMG.brideCloseup, IMG.candles, IMG.duo],
    tiers: [
      { id: "luxury-classic",   name: "Luxury Classic",    startingFrom: 799999,   note: "Full luxury · 100 guests baseline · 3 nights" },
      { id: "luxury-premium",   name: "Luxury Premium",    startingFrom: 1099999,  note: "Signature production · celebrity chef · heli option", featured: true },
      { id: "luxury-signature", name: "Luxury Signature",  startingFrom: 1499999,  note: "Full buyout · themed royal décor · 150 guests" },
    ],
  },
  // ============================================================
  // 5. ROYAL DESTINATION WEDDING · 151–300
  // ============================================================
  {
    id: "royal",
    icon: "crown",
    name: "Royal Destination Wedding",
    guestRange: "151 – 300 Guests",
    guestMax: 300,
    tagline: "A celebration on the scale of an ancient royal court",
    heroLine: "For families who want the grandeur of an old-world Indian royal wedding — with the sanctity of Triyuginarayan and the logistical mastery of THE KC INDIA.",
    image: IMG.aarti,
    accent: "royal",
    overview: "Our most ambitious offering: a 4-day royal wedding for up to 300 guests across multiple properties in Sersi and Rudraprayag, with themed production and dedicated helicopter arrivals.",
    highlights: [
      "Multiple-property buyout + partner luxury heritage stays",
      "Dedicated 30-member wedding production team + concierge per family",
      "Themed royal décor with brass, copper, marigold, chandelier",
      "Live celebrity chef pop-ups + curated cocktails + gourmet stations",
      "3-camera feature film + drone + LED wall + full production",
    ],
    included: [
      "3-property buyout + partner heritage stays (4 nights)",
      "6 fully-produced ceremonies (welcome + haldi + mehendi + sangeet + wedding + reception)",
      "Themed royal production with LED walls, chandeliers, brass detailing",
      "4-day gourmet meal plan with celebrity chef pop-ups",
      "Airport pickup for all 300 guests via mini-buses + luxury fleet",
      "Wedding director + 30-member team + concierge per family",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "Boutique Rooms · Partner Heritage",               perNight: 11500 },
      { key: "premium",   label: "Premium Rooms · KC + Partner Luxury",             perNight: 16500 },
      { key: "luxury",    label: "Royal Suites · KC Signature + Luxury Heritage",   perNight: 28500 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Buses × 4 + Travellers)",         flat: 485000 },
      { key: "premium",  label: "Premium Fleet (Urbania + Crysta + Buses)",         flat: 985000 },
      { key: "luxury",   label: "Luxury Fleet + Family Heli Arrivals + VIP Coach",  flat: 2250000 },
    ],
    decoration: [
      { key: "classic",   label: "Classic Royal Décor · 6 ceremonies",       flat: 685000 },
      { key: "signature", label: "Signature Themed Production · 6 ceremonies", flat: 1185000 },
      { key: "royal",     label: "Grand Royal Production · Full Themed Sets",   flat: 1985000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Veg · 6 meals",                     perGuest: 5500 },
      { key: "extended",   label: "Extended Multi-Cuisine Veg + Chaat + Grills",     perGuest: 7500 },
      { key: "luxury",     label: "Luxury Live Counters + Celebrity Chef + Bar",     perGuest: 11500 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo + Reels",                       flat: 485000 },
      { key: "cinematic",  label: "Cinematic · Feature Film + Same-Day Edit",         flat: 885000 },
      { key: "signature",  label: "Signature · 5-Cam Film + Drone + LED Wall Production", flat: 1485000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Guest arrivals across the day · Welcome dinner + aarti" },
      { day: "Day 1", label: "Grand Haldi morning · Grand Mehendi afternoon" },
      { day: "Day 2", label: "Grand Sangeet under themed production · Late-night cocktails" },
      { day: "Day 3", label: "Pheras at Triyuginarayan · Royal Wedding Lunch" },
      { day: "Day 4", label: "Royal Reception with themed production · Farewell brunch" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.aarti, IMG.candles, IMG.mandapDawn, IMG.brideCloseup, IMG.himalayaMorning, IMG.meadowMandap],
    tiers: [
      { id: "royal-classic",   name: "Royal Classic",    startingFrom: 1499999,  note: "Full royal · 200 guests · 4 nights · themed production" },
      { id: "royal-premium",   name: "Royal Premium",    startingFrom: 1999999,  note: "Grand royal · celebrity chef · heli arrivals", featured: true },
      { id: "royal-signature", name: "Royal Signature",  startingFrom: 2999999,  note: "300 guests · full production · full luxury inventory" },
    ],
  },
  // ============================================================
  // 6. TRADITIONAL VEDIC WEDDING
  // ============================================================
  {
    id: "vedic",
    icon: "om",
    name: "Traditional Vedic Wedding",
    guestRange: "Sacred · Any size",
    guestMax: 100,
    tagline: "The wedding the ancestors intended · Every mantra · Every ritual",
    heroLine: "For the couple who wants the fire, the mantra, and the Akhand Dhuni exactly the way the ancient texts prescribed — nothing more, nothing less.",
    image: IMG.templeMorning,
    accent: "saffron",
    overview: "Deeply spiritual, entirely traditional. Complete Vedic rituals performed by senior temple pandits at Triyuginarayan, with the sacred Akhand Dhuni fire as your witness. Simplicity is the luxury here.",
    highlights: [
      "Senior Vedic pandit ordained by the Temple Committee",
      "Complete traditional ceremony: Kanyadaan, Vivah Homam, Saptapadi, Ashirwad",
      "Akhand Dhuni offerings from the eternal fire that has burned since the Satyug",
      "Pure sattvic bhojan for guests — pahadi, ghee-cooked, temple-style",
      "Photography that respects sanctity — no drone, no flash during pheras",
    ],
    included: [
      "Temple coordination + full puja samagri",
      "Senior Vedic pandit for entire ceremony",
      "Basic floral décor honouring the temple aesthetic",
      "Sattvic wedding meal for guests",
      "Bride & groom accommodation for 2 nights",
      "Ceremony video for family archive (unobtrusive)",
    ],
    addons: ADDONS_STD.filter(a => !["fireworks","live_music"].includes(a.key)),
    accommodation: [
      { key: "boutique",  label: "Boutique Heritage · Sersi",              perNight: 6500 },
      { key: "premium",   label: "Premium Riverside · Rudraprayag",        perNight: 9500 },
      { key: "luxury",    label: "Kedarnath Cottage Signature Suite",      perNight: 17500 },
    ],
    transport: [
      { key: "standard", label: "Standard Fleet (Innova)",         flat: 25000 },
      { key: "premium",  label: "Premium Fleet (Crysta)",           flat: 65000 },
      { key: "luxury",   label: "Luxury Fleet + Helicopter Option", flat: 285000 },
    ],
    decoration: [
      { key: "classic",   label: "Sattvic Floral Mandap",         flat: 35000 },
      { key: "signature", label: "Temple Style · Brass + Bloom",   flat: 75000 },
      { key: "royal",     label: "Royal Vedic Mandap · Full",      flat: 145000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Pure Sattvic Bhojan",                perGuest: 1500 },
      { key: "extended",   label: "Sattvic Feast + Sweets",              perGuest: 2500 },
      { key: "luxury",     label: "Curated Temple-Style Fine Dining",    perGuest: 4200 },
    ],
    photography: [
      { key: "essentials", label: "Essentials · Photo Only · No flash",       flat: 35000 },
      { key: "cinematic",  label: "Cinematic · Unobtrusive Film",              flat: 95000 },
      { key: "signature",  label: "Signature · Full Sacred Documentary",       flat: 215000 },
    ],
    itinerary: [
      { day: "Day 0", label: "Arrival · Ganga snan at Rudraprayag · Evening aarti" },
      { day: "Day 1", label: "Purohit meeting · Pre-ceremony Ganesh puja · Rest" },
      { day: "Day 2", label: "Complete Vedic pheras + Akhand Dhuni offerings + Sattvic bhojan" },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.templeMorning, IMG.ganga, IMG.aarti, IMG.mandapDawn, IMG.himalayaMorning, IMG.candles],
    tiers: [
      { id: "vedic-budget",  name: "Vedic Budget",   startingFrom: 99999,   note: "Complete Vedic ceremony · essentials · 2 nights" },
      { id: "vedic-premium", name: "Vedic Premium",  startingFrom: 149999,  note: "Full ceremony + temple-style bhojan + film", featured: true },
      { id: "vedic-luxury",  name: "Vedic Luxury",   startingFrom: 249999,  note: "Full sacred documentary + KC suite + puja upgrades" },
    ],
  },
  // ============================================================
  // 7. CUSTOMIZED WEDDING
  // ============================================================
  {
    id: "custom",
    icon: "sparkles",
    name: "Customized Wedding",
    guestRange: "Fully Personalised",
    guestMax: 500,
    tagline: "Tell us what you dream · We hold every detail with care",
    heroLine: "For couples with a very specific vision — a fusion wedding, a queer ceremony, a bilingual affair, a themed production, or something we haven't yet imagined. Nothing off the shelf.",
    image: IMG.duo,
    accent: "royal",
    overview: "The best of everything, shaped entirely around your family and your vision. Every element of our other six collections is available — but recombined, rewritten, and personalised. Every quote here is bespoke.",
    highlights: [
      "Wedding + Char Dham yatra combos for adventurous couples",
      "Fusion weddings — bilingual, multi-tradition, dual mandap",
      "Queer and non-traditional ceremonies held with the same reverence",
      "Cinematic themed productions — Bollywood, royal Rajputana, modern minimal",
      "Anything you dream · we'll craft it",
    ],
    included: [
      "1:1 consultation with THE KC INDIA wedding director",
      "Fully custom itinerary + décor + menu",
      "All logistics, permits, and vendor management",
      "Any inclusion from our other six collections is available",
      "Dedicated production and hospitality team scaled to your vision",
    ],
    addons: ADDONS_STD,
    accommodation: [
      { key: "boutique",  label: "As per your vision", perNight: 8500 },
      { key: "premium",   label: "As per your vision", perNight: 13500 },
      { key: "luxury",    label: "As per your vision", perNight: 22500 },
    ],
    transport: [
      { key: "standard", label: "As per your vision", flat: 85000 },
      { key: "premium",  label: "As per your vision", flat: 285000 },
      { key: "luxury",   label: "As per your vision · Heli included", flat: 985000 },
    ],
    decoration: [
      { key: "classic",   label: "Custom themed décor · Classic",   flat: 185000 },
      { key: "signature", label: "Custom themed décor · Signature", flat: 485000 },
      { key: "royal",     label: "Full themed production · Royal",  flat: 985000 },
    ],
    catering: [
      { key: "pure_veg",   label: "Custom sattvic menu",          perGuest: 3500 },
      { key: "extended",   label: "Custom multi-cuisine menu",     perGuest: 5500 },
      { key: "luxury",     label: "Celebrity chef · full bar",     perGuest: 9500 },
    ],
    photography: [
      { key: "essentials", label: "Custom · Essentials",            flat: 185000 },
      { key: "cinematic",  label: "Custom · Cinematic feature film", flat: 485000 },
      { key: "signature",  label: "Custom · Full production",        flat: 985000 },
    ],
    itinerary: [
      { day: "Fully",  label: "Custom multi-day itinerary based on your vision — from a one-day intimate elopement to a week-long royal celebration." },
    ],
    faqs: FAQ_COMMON,
    gallery: [IMG.duo, IMG.mandapDawn, IMG.aarti, IMG.candles, IMG.brideCloseup, IMG.riversideVows],
    tiers: [
      { id: "custom-quote",  name: "Get Custom Quote",  startingFrom: null, note: "Every element personalised · bespoke pricing", featured: true },
    ],
  },
];

export const WEDDING_HERO_IMAGE = IMG.hero;

// ----- Lookup helpers --------------------------------------------------------
export const getCollection = (id) => WEDDING_COLLECTIONS.find(c => c.id === id);
export const getTier = (collectionId, tierId) => {
  const c = getCollection(collectionId);
  return c?.tiers.find(t => t.id === tierId);
};
export const findByPackageId = (pkgId) => {
  for (const c of WEDDING_COLLECTIONS) {
    const t = c.tiers.find(x => x.id === pkgId);
    if (t) return { collection: c, tier: t };
  }
  return null;
};

// ----- Estimator: given a collection + selections, return a range ------------
export const estimateRange = (collection, s) => {
  if (!collection || !s || collection.id === "custom") return null;
  const guests = Math.max(1, parseInt(s.guests || collection.guestMax, 10));
  const nights = Math.max(1, parseInt(s.nights || 2, 10));
  const acc  = collection.accommodation.find(x => x.key === s.accommodation) || collection.accommodation[0];
  const trs  = collection.transport   .find(x => x.key === s.transport)     || collection.transport[0];
  const dec  = collection.decoration  .find(x => x.key === s.decoration)    || collection.decoration[0];
  const cat  = collection.catering    .find(x => x.key === s.catering)      || collection.catering[0];
  const pho  = collection.photography .find(x => x.key === s.photography)   || collection.photography[0];
  const eventCount = Math.max(1, (s.events || []).length);
  const eventMultiplier = 1 + (eventCount - 1) * 0.08;
  const addonsTotal = (s.addons || []).reduce((sum, key) => {
    const a = collection.addons.find(x => x.key === key);
    return sum + (a?.price || 0);
  }, 0);
  const roomsNeeded = Math.ceil(guests / 2.4); // avg 2.4 guests per room
  const accTotal = acc.perNight * roomsNeeded * nights;
  const catTotal = cat.perGuest * guests;
  const base = accTotal + catTotal + trs.flat + dec.flat + pho.flat + addonsTotal;
  const withEvents = Math.round(base * eventMultiplier);
  const low  = Math.round(withEvents * 0.92);
  const high = Math.round(withEvents * 1.12);
  return { low, high };
};

// ----- Currency formatter ---------------------------------------------------
export const inr = (n) => {
  if (n == null) return "Get Custom Quote";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.?0+$/, "")} Cr`;
  if (n >=   100000) return `₹${(n /   100000).toFixed(2).replace(/\.?0+$/, "")} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};
